import styles from "../../../../styles/category-step.module.scss";

import { Icon } from "../../../components/core/Icon";

const SelectCategoryStep = ({ mountPayload }) => {
  const handler = (value) => {
    mountPayload({ mode: value });
  };

  return (
    <>
      <div className={styles.grid}>
        {/* <div
          className={styles.item}
          onClick={() => handler("pizza")}
        >
          <div className={styles.icon}>
            <Icon name="pizza-slice" size="lg" light />
          </div>
          <p>Pizza</p>
        </div> */}
        <div
          className={styles.item}
          onClick={() => handler("drink")}
        >
          <div className={styles.icon}>
            <Icon name="wine-glass" size="lg" light />
          </div>
          <p>Bebida</p>
        </div>
        <div className={styles.item} onClick={() => handler("step")}>
          <div className={styles.icon}>
            <Icon name="utensils" size="lg" light />
          </div>
          <p>Outros</p>
        </div>
      </div>
    </>
  );
};

export default SelectCategoryStep;
